import { render, staticRenderFns } from "./OrganizationProfileStatusBadge.vue?vue&type=template&id=c7c709c6&"
import script from "./OrganizationProfileStatusBadge.vue?vue&type=script&lang=js&"
export * from "./OrganizationProfileStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports